import React from 'react'
import TriggerConfig from './TriggerConfig'
import ConditionGroupConfig from './ConditionGroupConfig'
import ActionConfig from './ActionConfig'

const PANEL_META = {
    start: { title: 'Trigger', icon: 'fa-bolt', className: 'wf-panel-start' },
    conditionGroup: { title: 'Conditions', icon: 'fa-filter', className: 'wf-panel-condition' },
    action: { title: 'Action', icon: 'fa-play', className: 'wf-panel-action' },
}

const ConfigPanel = ({
    selectedNode,
    onClose,
    onUpdateNode,
    onDeleteNode,
    onDeleteCondition,
    allAvailableModels,
    triggerTypes,
    conditionTypes,
    actionTypesAndParams,
    availableModel,
}) => {
    if (!selectedNode) return null

    const nodeType = selectedNode.type
    const meta = PANEL_META[nodeType] || { title: 'Configure', icon: 'fa-cog', className: '' }

    return (
        <div className="wf-config-panel">
            <div className={`wf-config-panel-header ${meta.className}`}>
                <div className="wf-panel-header-content">
                    <div className="wf-panel-icon">
                        <i className={`fa ${meta.icon}`} />
                    </div>
                    <div>
                        <div className="wf-panel-title">{meta.title}</div>
                        <div className="wf-panel-subtitle">
                            {nodeType === 'start' && 'Configure when this workflow fires'}
                            {nodeType === 'conditionGroup' && 'Define conditions to match'}
                            {nodeType === 'action' && 'Set up what happens'}
                        </div>
                    </div>
                </div>
                <button className="wf-panel-close" onClick={onClose}>
                    <i className="fa fa-times" />
                </button>
            </div>
            <div className="wf-config-panel-body">
                {nodeType === 'start' && (
                    <TriggerConfig
                        nodeData={selectedNode.data}
                        allAvailableModels={allAvailableModels}
                        triggerTypes={triggerTypes}
                        onUpdate={(data) => onUpdateNode(selectedNode.id, data)}
                    />
                )}
                {nodeType === 'conditionGroup' && (
                    <ConditionGroupConfig
                        nodeData={selectedNode.data}
                        nodeId={selectedNode.id}
                        availableModel={availableModel}
                        conditionTypes={conditionTypes}
                        triggerType={null}
                        onUpdate={(data) => onUpdateNode(selectedNode.id, data)}
                        onDelete={onDeleteNode}
                        onDeleteCondition={onDeleteCondition}
                    />
                )}
                {nodeType === 'action' && (
                    <ActionConfig
                        nodeData={selectedNode.data}
                        nodeId={selectedNode.id}
                        actionTypesAndParams={actionTypesAndParams}
                        availableModel={availableModel}
                        onUpdate={(data) => onUpdateNode(selectedNode.id, data)}
                        onDelete={onDeleteNode}
                    />
                )}
            </div>
        </div>
    )
}

export default ConfigPanel
